
export const user = {
    action: "fa fa-users",
    title: "Users",
    permission: "user",
    items: [
        {
            title: "Admins",
            prefix: "I",
            link: "/users",
            permission: "user-index",
        },
        {
            title: "new main user",
            prefix: "C",
            link: "/create-user",
            permission: "user-create",
        },
        {
            title: "EmployeePage",
            prefix: "K",
            link: "/employees",
            permission: "user-employee-index",
        },
        {
            title: "Roles",
            prefix: "K",
            link: "/roles",
            permission: "user-role-index",
        },

    ],
}


